import { type FC } from 'react';
import { Link } from 'react-router';
import { Anchor, Box, Group, Text } from '@mantine/core';
import { IconCookie } from '@tabler/icons-react';
import styles from './Footer.module.css';

export const Footer: FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component='footer'
            className={styles.footer}
            w='100%'
        >
            <Group
                justify='space-between'
                align='center'
                p='sm'
                h='100%'
                gap={8}
            >
                <Text
                    size='sm'
                    c='dimmed'
                >
                    © {currentYear} Unite. Все права защищены.
                </Text>

                <Group gap='md'>
                    <Anchor
                        component={Link}
                        to='/privacy-policy'
                        size='sm'
                        c='dimmed'
                    >
                        <Group gap='xs'>
                            <IconCookie size={16} />

                            <Text size='sm'>Политика конфиденциальности и использования файлов cookie</Text>
                        </Group>
                    </Anchor>
                </Group>
            </Group>
        </Box>
    );
};
